(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4525],{

/***/ 60979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _fs = _interopRequireDefault(__webpack_require__(27316));
var _replaceSpecialCharacters = _interopRequireDefault(__webpack_require__(64426));
var dirPath = "/usr/src/app/log";
var createFolder = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _fs["default"].promises.mkdir(dirPath, {
              recursive: true
            });
          case 3:
            return _context.abrupt("return", {
              folderCreated: true
            });
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              folderCreated: false
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function createFolder() {
    return _ref.apply(this, arguments);
  };
}();
var writeFile = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(dirPath, newLogData) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _fs["default"].promises.appendFile("".concat(dirPath), "".concat(newLogData));
          case 3:
            return _context2.abrupt("return", true);
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            console.log("Error on write file", dirPath, _context2.t0);
          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return function writeFile(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var checkIfFolderExists = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return _fs["default"].promises.access(dirPath);
          case 3:
            return _context3.abrupt("return", true);
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", false);
          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 6]]);
  }));
  return function checkIfFolderExists() {
    return _ref3.apply(this, arguments);
  };
}();
var checkIfForbiddenUrlDirExists = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var forbiddenUrlExists;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return checkIfFolderExists();
          case 2:
            forbiddenUrlExists = _context4.sent;
            if (forbiddenUrlExists.isExist) {
              _context4.next = 7;
              break;
            }
            _context4.next = 6;
            return createFolder();
          case 6:
            return _context4.abrupt("return", _context4.sent);
          case 7:
            return _context4.abrupt("return", true);
          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function checkIfForbiddenUrlDirExists() {
    return _ref4.apply(this, arguments);
  };
}();
var writeLogToFile = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(logData) {
    var logFolderExists, currentDate, currentTime, dateAndTime, dateParts, month, day, fileName, newLogData;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return checkIfForbiddenUrlDirExists();
          case 2:
            logFolderExists = _context5.sent;
            if (!logFolderExists) {
              _context5.next = 14;
              break;
            }
            currentDate = new Date();
            currentTime = currentDate.toLocaleString("pl-PL", {
              timeZone: "Europe/Warsaw"
            });
            dateAndTime = currentTime.split(", ");
            dateParts = dateAndTime[0].split("/");
            month = dateParts[0].length === 1 ? "0".concat(dateParts[0]) : dateParts[0];
            day = dateParts[1].length === 1 ? "0".concat(dateParts[1]) : dateParts[1];
            fileName = "".concat(dateParts[2], "-").concat(month, "-").concat(day);
            newLogData = "[".concat(dateAndTime[1], "] ").concat(logData, " \r\n");
            _context5.next = 14;
            return writeFile("".concat(dirPath, "/").concat(fileName, ".log"), "".concat(newLogData));
          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function writeLogToFile(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
var rewriteExceptionOnForbiddenUrl = function rewriteExceptionOnForbiddenUrl(ctx) {
  if (ctx.res) {
    ctx.res.writeHead(301, {
      Location: (0, _replaceSpecialCharacters["default"])(ctx.asPath)
    });
    ctx.res.end();
  }
};
var checkIfUrlIsForbidden = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(ctx) {
    var _ctx$req$headers$xRe, _ctx$req, _ctx$req$headers, _ctx$req2, _ctx$req2$headers, ip, _ctx$language, _ctx$language2;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!/"|\.js|\.json|script|<|'|>|`|\(|\)|\[|\]`/.test(ctx.asPath)) {
              _context6.next = 7;
              break;
            }
            if (ctx.asPath.includes("'")) {
              rewriteExceptionOnForbiddenUrl(ctx);
            }
            ip = (_ctx$req$headers$xRe = ctx === null || ctx === void 0 ? void 0 : (_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : (_ctx$req$headers = _ctx$req.headers) === null || _ctx$req$headers === void 0 ? void 0 : _ctx$req$headers["x-real-ip"]) !== null && _ctx$req$headers$xRe !== void 0 ? _ctx$req$headers$xRe : ctx === null || ctx === void 0 ? void 0 : (_ctx$req2 = ctx.req) === null || _ctx$req2 === void 0 ? void 0 : (_ctx$req2$headers = _ctx$req2.headers) === null || _ctx$req2$headers === void 0 ? void 0 : _ctx$req2$headers["x-forwarded-for"];
            if (true) {
              _context6.next = 6;
              break;
            }
            _context6.next = 6;
            return writeLogToFile("".concat(ctx.asPath, " ").concat((_ctx$language = ctx.language) === null || _ctx$language === void 0 ? void 0 : _ctx$language.domain, " ").concat((_ctx$language2 = ctx.language) === null || _ctx$language2 === void 0 ? void 0 : _ctx$language2.language, " ").concat(ip));
          case 6:
            return _context6.abrupt("return", true);
          case 7:
            return _context6.abrupt("return", false);
          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function checkIfUrlIsForbidden(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
var _default = checkIfUrlIsForbidden;
exports.Z = _default;

/***/ }),

/***/ 37903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...categoryOrProductPage]",
      function () {
        return __webpack_require__(62262);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34885);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53746);
/* harmony import */ var _deosite_agent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37642);
/* harmony import */ var _deosite_api_hooks_common_useProductHeadOptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71855);
/* harmony import */ var _deosite_helpers_createSearchUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8371);
/* harmony import */ var _deosite_helpers_cache__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75800);
/* harmony import */ var _deosite_helpers_checkIfForbiddenUrlAndWriteToLogFile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60979);
/* harmony import */ var _c_category___WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14742);
/* harmony import */ var _productPage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69758);












function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var CategoryAndProductPage = function(props) {
    return props.pageType === "product" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deosite_api_hooks_common_useProductHeadOptions__WEBPACK_IMPORTED_MODULE_5__.ProductHeadOptionsContextProvider, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_productPage__WEBPACK_IMPORTED_MODULE_10__["default"], _objectSpread({}, props))
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_c_category___WEBPACK_IMPORTED_MODULE_9__["default"], _objectSpread({}, props));
};
CategoryAndProductPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx) {
        var ref, lastSlashPosition, language, questionMarkPosition, url, cacheFilePath, ref1, cacheFileExist, filenameCategoryCache, cachedRequest, response, activeFiltersString, ref2, ref3, responseWithPotentialFiltersInUrl, responseWithoutPotentialFiltersInUrl;
        return _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_deosite_helpers_checkIfForbiddenUrlAndWriteToLogFile__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ctx);
                case 3:
                    if (!_ctx.sent) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: {
                            statusCode: 404
                        }
                    });
                case 5:
                    lastSlashPosition = ctx.asPath.lastIndexOf("/");
                    language = ctx.language;
                    questionMarkPosition = ctx.asPath.lastIndexOf("?");
                    url = questionMarkPosition > -1 ? ctx.asPath.slice(1).slice(0, questionMarkPosition - 1) : ctx.asPath.slice(1);
                    cacheFilePath = "".concat(language.language, "/url/");
                    _ctx.next = 12;
                    return (0,_deosite_helpers_cache__WEBPACK_IMPORTED_MODULE_7__.readCacheFile)({
                        cacheFilePath: cacheFilePath,
                        contextRequest: ctx.req,
                        requestPath: ctx.asPath,
                        separateFolder: true
                    });
                case 12:
                    ref1 = _ctx.sent;
                    cacheFileExist = ref1.cacheFileExist;
                    filenameCategoryCache = ref1.filenameCategoryCache;
                    cachedRequest = ref1.cachedRequest;
                    response = cachedRequest;
                    ;
                    if (cacheFileExist) {
                        _ctx.next = 29;
                        break;
                    }
                    ;
                    _ctx.t0 = _slicedToArray;
                    _ctx.next = 23;
                    return Promise.all([
                        _deosite_agent__WEBPACK_IMPORTED_MODULE_4__.requests.get((0,_deosite_helpers_createSearchUrl__WEBPACK_IMPORTED_MODULE_6__.createSearchUrl)("/deosite/url-map", [
                            {
                                field: "request_path",
                                condition_type: "in",
                                value: url,
                                connector: _deosite_helpers_createSearchUrl__WEBPACK_IMPORTED_MODULE_6__.CONNECTORS.AND
                            }
                        ]), false, null, language),
                        _deosite_agent__WEBPACK_IMPORTED_MODULE_4__.requests.get((0,_deosite_helpers_createSearchUrl__WEBPACK_IMPORTED_MODULE_6__.createSearchUrl)("/deosite/url-map", [
                            {
                                field: "request_path",
                                condition_type: "in",
                                value: ctx.asPath.slice(1).slice(0, lastSlashPosition - 1),
                                connector: _deosite_helpers_createSearchUrl__WEBPACK_IMPORTED_MODULE_6__.CONNECTORS.AND
                            }
                        ]), false, null, language)
                    ]);
                case 23:
                    _ctx.t1 = _ctx.sent;
                    ref3 = (0, _ctx.t0)(_ctx.t1, 2);
                    responseWithPotentialFiltersInUrl = ref3[0];
                    responseWithoutPotentialFiltersInUrl = ref3[1];
                    response = responseWithoutPotentialFiltersInUrl;
                    if ((responseWithPotentialFiltersInUrl === null || responseWithPotentialFiltersInUrl === void 0 ? void 0 : (ref2 = responseWithPotentialFiltersInUrl.items) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) {
                        activeFiltersString = ctx.asPath.slice(1).slice(lastSlashPosition);
                    } else {
                        response = responseWithPotentialFiltersInUrl;
                        activeFiltersString = questionMarkPosition > -1 ? ctx.asPath.slice(questionMarkPosition) : false;
                    }
                case 29:
                    if (!((response === null || response === void 0 ? void 0 : (ref = response.items) === null || ref === void 0 ? void 0 : ref.length) === 0 || Object.keys(response).length === 0 && response.constructor === Object)) {
                        _ctx.next = 31;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: {
                            statusCode: 404
                        }
                    });
                case 31:
                    if (!(cacheFileExist === false)) {
                        _ctx.next = 36;
                        break;
                    }
                    _ctx.next = 34;
                    return (0,_deosite_helpers_cache__WEBPACK_IMPORTED_MODULE_7__.saveCacheFile)({
                        cacheFilePath: cacheFilePath,
                        filenameCategoryCache: filenameCategoryCache,
                        result: _objectSpread({}, response, {
                            activeFiltersString: activeFiltersString
                        }),
                        separateFolder: true
                    });
                case 34:
                    _ctx.next = 37;
                    break;
                case 36:
                    if (cachedRequest) {
                        response = cachedRequest;
                        activeFiltersString = cachedRequest === null || cachedRequest === void 0 ? void 0 : cachedRequest.activeFiltersString;
                    }
                case 37:
                    if (activeFiltersString) {
                        activeFiltersString = activeFiltersString.replace(/(\?|\&)p=[0-9]*/g, "");
                    }
                    _ctx.prev = 38;
                    if (!(response.items[0].entity_type === "category")) {
                        _ctx.next = 47;
                        break;
                    }
                    _ctx.t2 = _objectSpread;
                    _ctx.t3 = {};
                    _ctx.next = 44;
                    return _c_category___WEBPACK_IMPORTED_MODULE_9__["default"].getInitialProps(_objectSpread({}, ctx, {
                        query: _objectSpread({}, ctx.query, {
                            category: response.items[0].entity_id,
                            requestPath: response.items[0].request_path,
                            activeFiltersString: activeFiltersString
                        })
                    }));
                case 44:
                    _ctx.t4 = _ctx.sent;
                    _ctx.t5 = {
                        pageType: "category"
                    };
                    return _ctx.abrupt("return", (0, _ctx.t2)(_ctx.t3, _ctx.t4, _ctx.t5));
                case 47:
                    _ctx.t6 = _objectSpread;
                    _ctx.t7 = {};
                    _ctx.next = 51;
                    return _productPage__WEBPACK_IMPORTED_MODULE_10__["default"].getInitialProps(_objectSpread({}, ctx, {
                        query: _objectSpread({}, ctx.query, {
                            productPage: response.items[0].metadata.sku
                        })
                    }));
                case 51:
                    _ctx.t8 = _ctx.sent;
                    _ctx.t9 = {
                        pageType: "product"
                    };
                    return _ctx.abrupt("return", (0, _ctx.t6)(_ctx.t7, _ctx.t8, _ctx.t9));
                case 56:
                    _ctx.prev = 56;
                    _ctx.t10 = _ctx["catch"](38);
                    console.log("Category or product page error: ".concat(_ctx.t10, ", ctx query: ").concat(JSON.stringify(ctx.query), " response item:  ").concat(JSON.stringify(response === null || response === void 0 ? void 0 : response.items[0])));
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 60:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                38,
                56
            ]
        ]);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_3__.withRouter)(CategoryAndProductPage));


/***/ }),

/***/ 27316:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [902,6002,2067,3556,3068,9281,9316,1143,2520,6346,4239,4284,4742,9774,2888,179], function() { return __webpack_exec__(37903); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);